var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFailure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 126,
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.367188,
    y: 0.367188,
    width: 125.263,
    height: 125.263,
    rx: 62.6316,
    fill: "#FBD0D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.4727,
    y: 34.9062,
    width: 6.53251,
    height: 72.9298,
    transform: "rotate(45 86.4727 34.9062)",
    fill: "#9C3B35"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.9023,
    y: 39.5273,
    width: 6.53251,
    height: 72.9298,
    transform: "rotate(-45 34.9023 39.5273)",
    fill: "#9C3B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailure);
export default __webpack_public_path__ + "static/media/failure.36efa6e103cdda5360aba622bc5f3d4c.svg";
export { ForwardRef as ReactComponent };